var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.977 9.67402C16.7411 8.0569 14.9754 8.25358 9.764 8.57494C6.05092 8.8039 1.7548 13.7138 1.43292 17.5245C1.36477 18.3312 1.8682 21.7379 1.95147 22.4979C2.02693 23.1865 1.77281 23.9058 1.83077 24.5916C1.86823 25.0349 2.32051 24.7477 3.19814 24.9225C3.82122 25.0466 4.88936 25.2161 5.77421 25.4503C7.9054 26.0143 8.1385 25.2505 9.76395 25.1131C11.3894 24.9757 14.4016 23.3587 15.4854 22.0778C16.3038 21.1106 17.9975 18.2248 17.9975 16.818C17.9975 13.6778 17.1747 10.2526 16.977 9.67402Z",
    fill: "#FBE54D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.764 8.57494L9.81016 9.32351L9.764 8.57494ZM16.977 9.67402L16.2348 9.78228L16.2448 9.85091L16.2673 9.91655L16.977 9.67402ZM17.9975 16.818L18.7475 16.818L17.9975 16.818ZM15.4854 22.0778L16.0579 22.5623L15.4854 22.0778ZM5.77421 25.4503L5.96609 24.7252L5.96608 24.7252L5.77421 25.4503ZM1.43292 17.5245L2.18026 17.5876L1.43292 17.5245ZM1.95147 22.4979L1.20594 22.5796L1.95147 22.4979ZM3.19814 24.9225L3.05163 25.6581L3.05163 25.6581L3.19814 24.9225ZM9.81016 9.32351C12.4609 9.16006 14.1174 9.03887 15.1613 9.14379C15.6769 9.19561 15.9228 9.29455 16.0419 9.38121C16.1219 9.43952 16.1977 9.52758 16.2348 9.78228L17.7191 9.56577C17.6383 9.01191 17.4049 8.51813 16.9247 8.16855C16.4835 7.84731 15.9181 7.7123 15.3113 7.65131C14.1106 7.53063 12.2785 7.66846 9.71784 7.82636L9.81016 9.32351ZM16.2673 9.91655C16.441 10.425 17.2475 13.7682 17.2475 16.818L18.7475 16.818C18.7475 13.5873 17.9084 10.0803 17.6867 9.4315L16.2673 9.91655ZM17.2475 16.818C17.2475 17.0421 17.175 17.3909 17.0133 17.8465C16.8564 18.2887 16.6346 18.7794 16.382 19.2687C15.8717 20.257 15.2733 21.1673 14.9128 21.5934L16.0579 22.5623C16.5159 22.0211 17.1736 21.0049 17.7148 19.9568C17.9879 19.4279 18.2407 18.8729 18.4269 18.3482C18.6084 17.8368 18.7475 17.2973 18.7475 16.818L17.2475 16.818ZM14.9128 21.5934C14.4616 22.1267 13.5353 22.7976 12.4752 23.3623C11.4111 23.9292 10.36 24.31 9.70079 24.3658L9.8271 25.8604C10.7933 25.7788 12.0611 25.2825 13.1804 24.6862C14.3037 24.0879 15.4254 23.3098 16.0579 22.5623L14.9128 21.5934ZM9.70079 24.3658C8.80696 24.4413 8.15898 24.7174 7.76951 24.819C7.38044 24.9204 6.92139 24.978 5.96609 24.7252L5.58233 26.1753C6.75821 26.4865 7.48131 26.4442 8.14795 26.2704C8.81419 26.0967 9.09548 25.9223 9.8271 25.8604L9.70079 24.3658ZM2.18026 17.5876C2.32266 15.9017 3.37008 13.8702 4.88116 12.2117C6.39991 10.5447 8.23344 9.42074 9.81016 9.32351L9.71784 7.82636C7.58148 7.95809 5.41041 9.40354 3.77236 11.2014C2.12664 13.0077 0.865056 15.3365 0.685579 17.4613L2.18026 17.5876ZM2.5781 24.5284C2.55732 24.2825 2.59152 24.017 2.64111 23.6448C2.68629 23.3058 2.7462 22.8651 2.69701 22.4162L1.20594 22.5796C1.2322 22.8193 1.20278 23.0825 1.15425 23.4467C1.11014 23.7778 1.04625 24.2148 1.08343 24.6548L2.5781 24.5284ZM2.69701 22.4162C2.65555 22.0378 2.50363 20.9525 2.3799 19.9379C2.3164 19.4172 2.25844 18.9018 2.22063 18.4697C2.18094 18.0161 2.16949 17.715 2.18026 17.5876L0.685579 17.4613C0.662269 17.7373 0.688197 18.1646 0.726338 18.6004C0.766351 19.0577 0.826679 19.5927 0.890929 20.1195C1.02269 21.1999 1.16413 22.198 1.20594 22.5796L2.69701 22.4162ZM5.96608 24.7252C5.05211 24.4833 3.92151 24.3019 3.34466 24.187L3.05163 25.6581C3.72093 25.7914 4.72662 25.9488 5.58233 26.1753L5.96608 24.7252ZM3.34466 24.187C2.82106 24.0827 2.36535 24.1115 2.2174 24.108C2.17528 24.1069 2.16943 24.1047 2.18156 24.1069C2.19438 24.1092 2.25645 24.1214 2.33268 24.1687C2.41907 24.2224 2.48929 24.3 2.53349 24.3873C2.57239 24.4642 2.57753 24.5217 2.5781 24.5284L1.08343 24.6548C1.1045 24.904 1.20758 25.2356 1.54094 25.4428C1.79391 25.6 2.07298 25.6049 2.18138 25.6075C2.48834 25.6149 2.69759 25.5875 3.05163 25.6581L3.34466 24.187Z",
    fill: "#351771"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.043,
    cy: 24.5234,
    r: 0.5,
    fill: "#351771"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 19.519,
    r: 0.5,
    fill: "#351771"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04297,
    cy: 21.5234,
    r: 0.5,
    fill: "#351771"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04297,
    cy: 20.519,
    r: 0.5,
    fill: "#351771"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.04297,
    cy: 19.519,
    r: 0.5,
    fill: "#351771"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04297,
    cy: 18.519,
    r: 0.5,
    fill: "#351771"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 18.519,
    r: 0.5,
    fill: "#351771"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04297,
    cy: 17.519,
    r: 0.5,
    fill: "#351771"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04297,
    cy: 14.519,
    r: 0.5,
    fill: "#351771"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 20.5234,
    r: 0.5,
    fill: "#351771"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.04297,
    cy: 20.519,
    r: 0.5,
    fill: "#351771"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04297,
    cy: 21.519,
    r: 0.5,
    fill: "#351771"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04297,
    cy: 23.519,
    r: 0.5,
    fill: "#351771"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.04297,
    cy: 24.519,
    r: 0.5,
    fill: "#351771"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.04297,
    cy: 21.519,
    r: 0.5,
    fill: "#351771"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.04297,
    cy: 19.519,
    r: 0.5,
    fill: "#351771"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 22.5234,
    r: 0.5,
    fill: "#351771"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.043,
    cy: 17.519,
    r: 0.5,
    fill: "#351771"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.54297,
    cy: 24.019,
    r: 1,
    fill: "#351771"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.04297,
    cy: 22.519,
    r: 0.5,
    fill: "#351771"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 24.5234,
    r: 0.5,
    fill: "#351771"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.043,
    cy: 19.519,
    r: 0.5,
    fill: "#351771"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04297,
    cy: 23.5234,
    r: 0.5,
    fill: "#351771"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04297,
    cy: 22.519,
    r: 0.5,
    fill: "#351771"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04297,
    cy: 17.519,
    r: 0.5,
    fill: "#351771"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04297,
    cy: 16.519,
    r: 0.5,
    fill: "#351771"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04297,
    cy: 15.519,
    r: 0.5,
    fill: "#351771"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.04297,
    cy: 15.519,
    r: 0.5,
    fill: "#351771"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 16.519,
    r: 0.5,
    fill: "#351771"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.04297,
    cy: 22.519,
    r: 0.5,
    fill: "#351771"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.043,
    cy: 22.519,
    r: 0.5,
    fill: "#351771"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.043,
    cy: 23.519,
    r: 0.5,
    fill: "#351771"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 23.519,
    r: 0.5,
    fill: "#351771"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.04297,
    cy: 21.519,
    r: 0.5,
    fill: "#351771"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04297,
    cy: 22.519,
    r: 0.5,
    fill: "#351771"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.04297,
    cy: 24.519,
    r: 0.5,
    fill: "#351771"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.04297,
    cy: 23.519,
    r: 0.5,
    fill: "#351771"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04297,
    cy: 24.519,
    r: 0.5,
    fill: "#351771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8366 7.10834C15.8572 7.02982 16.8217 7.14907 16.5637 6.4803C16.438 6.15449 16.4074 5.30228 15.4653 4.36022C15.0561 3.69878 14.6817 2.89201 13.659 2.47652C11.6964 1.6792 8.5419 1.85222 8.71318 2.4765C9.358 4.82673 10.5256 6.00894 11.6971 6.59266C12.9515 7.21772 14.2104 7.15652 14.8366 7.10834Z",
    fill: "#351771"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6089 6.83813C16.059 6.79583 15.5394 6.86007 15.6784 6.49978C15.7461 6.32425 15.7626 5.86514 16.2701 5.35761C16.4906 5.00127 16.6923 4.56663 17.2433 4.34278C18.3006 3.91324 20 4.00645 19.9078 4.34278C19.5604 5.60894 18.9313 6.24584 18.3002 6.56032C17.6244 6.89706 16.9462 6.86409 16.6089 6.83813Z",
    fill: "#351771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredits);
export default __webpack_public_path__ + "static/media/credits.11251de83d575c24232ff0701c01b633.svg";
export { ForwardRef as ReactComponent };